module.exports = __webpack_public_path__ + "img/Frente-12-02 open.fdd0bf22.jpg";